import { IsAliveService } from './isAliveService';
import { Injectable } from '@angular/core';
import { IsLoadingService } from 'src/app/shared/is-loading/is-loading.service';
import { UserService } from '../user/user.service';
import { InitService } from './init-service.interface';
import { RootService } from 'src/app/root/home/root.service';

@Injectable({
  providedIn: 'root',
})
export class GlobalInitService {
  get isLoadingKey() {
    return 'global-init';
  }

  private servicesToInit: InitService[];

  constructor(
    private isAliveService: IsAliveService,
    private isLoadingService: IsLoadingService,
    private userService: UserService,
    private rootService: RootService
  ) {
    this.servicesToInit = [isAliveService, userService, rootService];
  }

  async init() {
    await this.isLoadingService.add(Promise.all(this.servicesToInit.map(s => s.init())), { key: this.isLoadingKey });

    return this.userService.get() !== null;
  }
}
